import { render, staticRenderFns } from "./StoreRcView.vue?vue&type=template&id=bafc4d2e&scoped=true&"
import script from "./StoreRcView.vue?vue&type=script&lang=js&"
export * from "./StoreRcView.vue?vue&type=script&lang=js&"
import style0 from "./StoreRcView.vue?vue&type=style&index=0&id=bafc4d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafc4d2e",
  null
  
)

export default component.exports